import { connect } from 'react-redux';
import Incoming from './Incoming';
import {
  getIncoming,
  getIncomingListAreas,
  getIncomingListBoxes,
  getIncomingListStocks,
  getIncomingReject,
  getIncomingErrorFalse,
  getIncomingClear,
  setInitialStateIncoming
} from '../../store/actions/incoming';
import {
  modalPostStockOpen,
  modalSKZipOpen,
  modalPostStockConsignmentOpen
} from '../../store/actions/modal';

import { modalErrorOpen } from '../../store/actions/modalError';

const mapStateToProps = ({
  incomingReducer,
  settingsReducer,
  tabsReducer,
  userReducer
}) => ({
  incomingReducer,
  settingsReducer,
  tabsReducer,
  userReducer
});
const mapDispatchToProps = {
  getIncoming,
  getIncomingListAreas,
  getIncomingListBoxes,
  getIncomingListStocks,
  getIncomingReject,
  getIncomingErrorFalse,
  getIncomingClear,
  modalPostStockOpen,
  modalErrorOpen,
  modalSKZipOpen,
  modalPostStockConsignmentOpen,
  setInitialStateIncoming
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Incoming);
